export default "__VITE_ASSET__CDItQMv6__"